<template>
	<fieldset id="fs-buildingType" class="pt-3 pb-3">
		<div class="container pt-5 pb-2">
			<div class="row no-gutters">
				<div class="col-2">
					<div class="field-wrap size-big">
						<label>Building Type</label>

						<div class="row no-gutters field-icon">
							<select
								v-model="formData.buildingType"
								:disabled="disabled"
							>
								<option
									v-for="value in buildingTypeOptions"
									:key="value"
									:value="value"
									>
									{{strings[`${value}_label`]}}
								</option>
							</select>
						</div>

						<div class="suffix-wrap">
							<p v-if="disabled" class="desc locked-note">
								<i class="fa-solid fa-lock"></i> Locked while Custom Load is enabled
							</p>
							<p v-else class="desc"></p>
						</div>
					</div>
				</div>

				<div class="col-6 pl-5">
					<div class="field-wrap size-big">
						<p>{{strings[`${formData.buildingType}_description`]}}</p>
					</div>
				</div>
			</div>
		</div>
	</fieldset>
</template>

<script>
import formData from '@/components/Sizer/form-data-store'
import strings from './strings.js'

export default {
	name: 'BuildingTypeSelect',

	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
	},

	data: () => ({
		strings,
		formData,
		buildingTypeOptions: [
			"multi_family",
			"mens_dorm",
			"womens_dorm",
			"motel",
			"elementary_school",
			"junior_high",
			"senior_high",
			"nursing_home",
			"food_service_a",
			"food_service_b",
			"office_building",
		],
	}),
}
</script>

<style scoped>
.locked-note {
	color: #6c757d;
	font-size: 0.8rem;
	margin-top: 4px;
}

.locked-note i {
	margin-right: 4px;
}

select:disabled {
	background-color: #e9ecef;
	cursor: not-allowed;
}
</style>
